var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.entry.date_entered))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.entry.owner_name))]),_vm._v(" "),_c('status-icon-cell',{attrs:{"data":_vm.data,"value":_vm.entry.status}}),_vm._v(" "),_c('comment-cell',{attrs:{"comment":_vm.entry.comment,"username":_vm.entry.entered_user_name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }